//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TaggedObject.js";
let d=[[[0,"AlignHorizontalVertical",1,0],[0,"AlignToDimensionLine",1,0],[0,"AutoAlignment",1,0],[0,"PositionAtSnapPoint",1,0],[0,"PositionOnMargin",1,0],[0,"PositionRelativeToGeom",1,0],[0,"PositionRelativeToView",1,0],[0,"StackAnnotation",1,0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Annotations.OriginAlignmentBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.OriginAlignmentBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.OriginAlignmentBuilder.AutoAlignmentType = Object.freeze({
    "Associative" : "Associative", "NonAssociative" : "NonAssociative", "Off" : "Off"});

export default SPLM;